import { useEffect, useRef, useState } from 'react';
import { FilesGallery } from '../components/FilesGalleryView';

export const useGalleryVirtualization = ({ data }: { data: FilesGallery }) => {
  const [isVisibleInViewport, setVisibleInViewport] = useState(false);
  const [loadCount, setLoadCount] = useState(20);
  const loaderRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setVisibleInViewport(entry.isIntersecting);
      },
      { rootMargin: '-50px' },
    );
    if (loaderRef?.current) observer.observe(loaderRef.current);

    return () => observer.disconnect();
  }, [loaderRef]);

  useEffect(() => {
    if (isVisibleInViewport && loadCount + 20 < data.length) {
      setLoadCount((prev) => prev + 20);
    }
  }, [isVisibleInViewport]);

  const viewData = data.slice(0, loadCount + 20);

  return {
    loaderRef,
    viewData,
  };
};
